module.exports = __webpack_public_path__ + "img/vector-right.2102ce59.svg";